import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComandaRoutingModule } from './comanda-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ComandaRoutingModule
  ]
})
export class ComandaModule { }
